<template>
  <div :class="classObj" class="app-wrapper">
    <div
      v-if="device === 'mobile' && sidebar.opened"
      class="drawer-bg"
      @click="handleClickOutside"
    />
    <sidebar :key="n" ref="sidebar" class="sidebar-container" />

    <div class="main-container">
      <div :class="{ 'fixed-header': fixedHeader }">
        <navbar
          @showProxyApprovalSettingDialog="
            $refs['proxyApprovalSettingDialogRef'].open()
          "
        />
      </div>

      <app-main />
    </div>
    <water-mark v-if="showWaterMark" />
    <proxyApprovalSettingDialog
      ref="proxyApprovalSettingDialogRef"
    ></proxyApprovalSettingDialog>
  </div>
</template>

<script>
  import { AppMain, Navbar, Sidebar } from './components';
  import ResizeMixin from './mixin/ResizeHandler';
  import { mapState } from 'vuex';
  import WaterMark from '@/components/WaterMark/index';
  import { ROLES_TENANT, getPlateForm } from '@/utils/auth';
  import proxyApprovalSettingDialog from '@/views/login/components/proxyApprovalSettingDialog';
  export default {
    name: 'Layout',
    data() {
      return {
        n: 1,
        showWaterMark: false
      };
    },
    components: {
      proxyApprovalSettingDialog,
      AppMain,
      Navbar,
      Sidebar,
      WaterMark
    },
    mixins: [ResizeMixin],
    mounted() {
      const watermarkConfigSelected = localFun.get('watermarkConfigSelected')
        ? JSON.parse(localFun.get('watermarkConfigSelected'))
        : [];

      if (
        getPlateForm() === ROLES_TENANT &&
        watermarkConfigSelected.length > 0
      ) {
        this.showWaterMark = true;
      }
    },
    computed: {
      ...mapState({
        sidebar: (state) => state.app.sidebar,
        device: (state) => state.app.device,
        fixedHeader: (state) => state.settings.fixedHeader
      }),
      classObj() {
        return {
          hideSidebar: !this.sidebar.opened,
          openSidebar: this.sidebar.opened,
          withoutAnimation: this.sidebar.withoutAnimation,
          mobile: this.device === 'mobile'
        };
      }
    },
    methods: {
      handleClickOutside() {
        this.$store.dispatch('app/closeSideBar', { withoutAnimation: false });
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import '@/styles/mixin.scss';

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;

    &.mobile.openSidebar {
      position: fixed;
      top: 0;
    }
  }

  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: calc(100% - #{$sideBarWidth});
    transition: width 0.28s;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 54px);
  }

  .mobile .fixed-header {
    width: 100%;
  }
</style>
